import { render, staticRenderFns } from "./PoliciesEstatePlanning.vue?vue&type=template&id=5df3730a"
import script from "./PoliciesEstatePlanning.vue?vue&type=script&lang=js"
export * from "./PoliciesEstatePlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports